import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Api } from '@blink/components';
import { LOCAL_STORAGE, LocalStorage } from '@blink/components/src/utils';
import { ReactComponent as LogoutIcon } from '@blink/assets/src/icons/logout.svg';

import { useHandleSignIn } from '@/shared/hooks/useHandleSignIn';
import { Store } from '@/shared/store';
import { Button, ButtonVariant } from '@/shared/ui';
import { LoggedInProvider } from '@/app/providers';
import { UserControls } from '@/components/UserControls';
import { setUserLockedAction } from '@/shared/store/organization/actions';

export const AuthButton = () => {
    const handleSignIn = useHandleSignIn();

    const { locked } = useSelector((state: Store) => ({
        locked: state.organization.locked,
    }));

    return (
        <div className='h-[44px] flex flex-row justify-center items-center rounded'>
            {locked ? (
                <LogoutButton />
            ) : (
                <LoggedInProvider
                    haveAuth={<UserControls />}
                    haveNoAuth={
                        <Button
                            variant={ButtonVariant.Primary}
                            onClick={handleSignIn}
                            name='sign-in'
                            className='flex justify-center items-center w-[152px] text-md h-[44px]'
                        >
                            Sign In
                        </Button>
                    }
                />
            )}
        </div>
    );
};

function LogoutButton() {
    const dispatch = useDispatch();

    const logout = useMemo(() => {
        return (
            `${Api.API_AUTH_ENDPOINT}/sign_out?rd=` +
            encodeURIComponent(
                `${Api.OAUTH_IDP_LOGOUT_ENDPOINT}?client_id=${Api.API_AUTH_CLIENT_ID}&returnTo=${window.location.origin}`,
            )
        );
    }, []);

    const handleLogout = () => {
        LocalStorage.setItem(LOCAL_STORAGE.LOGGED_IN, '');
        dispatch(setUserLockedAction(false));
        window.location.href = logout;
    };

    return (
        <Button leftIcon={<LogoutIcon />} onClick={handleLogout} variant={ButtonVariant.Secondary}>
            Log out
        </Button>
    );
}
